'use client'

import { useEffect, useRef, useState } from 'react'
interface IUseCountdown {
  initialValue: number
  interval?: number
  onComplete?: () => void
}
export function useCountdown({ initialValue, interval = 1000, onComplete }: IUseCountdown) {
  const [count, setCount] = useState(initialValue)
  const [isActive, setIsActive] = useState(false)
  const onCompleteRef = useRef(onComplete)

  useEffect(() => {
    onCompleteRef.current = onComplete
  }, [onComplete])

  useEffect(() => {
    setCount(initialValue)
  }, [initialValue])

  useEffect(() => {
    let timer: NodeJS.Timeout
    if (isActive && count > 0) {
      timer = setInterval(() => {
        setCount((prev) => prev - 1)
      }, interval)
    } else if (count === 0 && isActive) {
      setIsActive(false)
      if (onCompleteRef.current) {
        onCompleteRef.current()
      }
    }

    return () => clearInterval(timer)
  }, [isActive, count, interval])

  const start = () => setIsActive(true)
  const pause = () => setIsActive(false)
  const reset = () => {
    setIsActive(false)
    setCount(initialValue)
  }

  return { count, isActive, start, pause, reset }
}
